import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.org.tree');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-org-tree',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.org.tree/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabOrgTreeComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public tree: any[] = [];
    public selectedNode: any = null;
    public members: any[] = [];
    public loaded: boolean = false;

    public showCreate: boolean = false;
    public newNode: any = { name: '', parent_id: '', type: 'team', description: '' };

    public showAddMember: boolean = false;
    public memberInput: string = '';
    public memberPosition: string = '';

    public typeLabels: any = { company: '회사', division: '본부/부서', team: '팀' };

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const res = await wiz.call("init", {});
        if (res.code === 200) {
            this.tree = res.data.tree || [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public async select(node: any) {
        this.selectedNode = node;
        const res = await wiz.call("members", { node_id: node.id });
        if (res.code === 200) {
            this.members = res.data.rows || [];
        }
        await this.service.render();
    }

    public openCreate(parent: any = null) {
        this.newNode = {
            name: '',
            parent_id: parent ? parent.id : '',
            type: parent ? 'team' : 'division',
            description: '',
        };
        this.showCreate = true;
    }

    public async createNode() {
        if (!this.newNode.name?.trim()) {
            this.service.alert.error('이름을 입력하세요.');
            return;
        }
        const res = await wiz.call("create", this.newNode);
        if (res.code === 200) {
            this.showCreate = false;
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || '생성 실패');
        }
    }

    public async deleteNode(node: any) {
        if (!confirm(`'${node.name}' 부서와 하위 부서를 모두 삭제하시겠습니까?`)) return;
        const res = await wiz.call("remove", { id: node.id });
        if (res.code === 200) {
            if (this.selectedNode?.id === node.id) {
                this.selectedNode = null;
                this.members = [];
            }
            await this.load();
        }
    }

    public async addMember() {
        if (!this.selectedNode || !this.memberInput.trim()) return;
        const res = await wiz.call("add_member", {
            node_id: this.selectedNode.id,
            user_id: this.memberInput.trim(),
            position: this.memberPosition,
        });
        if (res.code === 200) {
            this.memberInput = '';
            this.memberPosition = '';
            this.showAddMember = false;
            await this.select(this.selectedNode);
        } else {
            this.service.alert.error(res.data?.message || '추가 실패');
        }
    }

    public async removeMember(m: any) {
        if (!confirm(`'${m.name || m.id}'을(를) 부서에서 제외하시겠습니까?`)) return;
        const res = await wiz.call("remove_member", {
            node_id: this.selectedNode.id, user_id: m.id,
        });
        if (res.code === 200) {
            await this.select(this.selectedNode);
        }
    }
}

export default PortalLpsysadminCollabOrgTreeComponent;